import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './custom-styles.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import GA4React from "ga-4-react";

const root = ReactDOM.createRoot(document.getElementById('root'));

const ga4react = new GA4React("G-54PK5TGP14");
ga4react.initialize().then().catch()

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
